<div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 overflow-hidden">
  <button
    type="button"
    (click)="toggleCollapsed()"
    class="w-full flex items-center justify-between px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
    <div class="flex items-center gap-2">
      <svg class="h-4 w-4 text-brand-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
      </svg>
      <span class="text-xs font-semibold uppercase tracking-wider text-gray-700 dark:text-gray-300">Contexto CRM</span>
    </div>
    <svg class="h-4 w-4 text-gray-400 transition-transform" [class.rotate-180]="collapsed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>

  @if (!collapsed) {
  <div class="px-3 pb-3 space-y-3">

    @if (loading) {
    <div class="flex justify-center py-3">
      <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
    </div>
    } @else if (errorMsg) {
    <p class="text-xs text-error-600 dark:text-error-400">{{ errorMsg }}</p>
    } @else if (!hasAnyContent()) {
    <p class="text-xs text-gray-500 dark:text-gray-400 italic">Sin contexto CRM asociado a esta llamada.</p>
    } @else {

    <!-- Contact + Company -->
    @if (context?.contact) {
    <div class="flex items-start gap-3">
      <button
        type="button"
        (click)="goToContact(context?.contact?.id)"
        class="flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 dark:bg-brand-500/20 text-brand-700 dark:text-brand-400 text-xs font-bold flex-shrink-0 hover:bg-brand-200 dark:hover:bg-brand-500/30 transition-colors"
        title="Ver contacto">
        {{ contactInitials() }}
      </button>
      <div class="min-w-0 flex-1">
        <button
          type="button"
          (click)="goToContact(context?.contact?.id)"
          class="text-sm font-semibold text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400 transition-colors truncate w-full text-left">
          {{ context?.contact?.name || 'Contacto sin nombre' }}
        </button>
        @if (context?.contact?.email) {
        <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ context?.contact?.email }}</p>
        }
        @if (context?.company) {
        <button
          type="button"
          (click)="goToCompany(context?.company?.id)"
          class="text-xs text-gray-600 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors truncate w-full text-left">
          ↳ {{ context?.company?.name }}
        </button>
        }
      </div>
    </div>
    } @else if (context?.company) {
    <button
      type="button"
      (click)="goToCompany(context?.company?.id)"
      class="block w-full text-left">
      <p class="text-sm font-medium text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400 transition-colors">
        {{ context?.company?.name }}
      </p>
      <p class="text-xs text-gray-500 dark:text-gray-400">Empresa</p>
    </button>
    }

    <!-- Deals -->
    @if ((context?.deals?.length ?? 0) > 0) {
    <div>
      <p class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1.5">
        Deals abiertos ({{ context?.deals?.length }})
      </p>
      <div class="space-y-1">
        @for (d of context?.deals; track trackById($index, d)) {
        <button
          type="button"
          (click)="goToDeal(d.id)"
          class="w-full flex items-center justify-between gap-2 px-2 py-1.5 rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 hover:border-brand-300 dark:hover:border-brand-500/40 hover:bg-brand-50/50 dark:hover:bg-brand-500/5 transition-colors text-left">
          <div class="min-w-0 flex-1">
            <p class="text-xs font-medium text-gray-900 dark:text-white truncate">{{ d.title || 'Sin título' }}</p>
            @if (d.status) {
            <p class="text-[10px] text-gray-500 dark:text-gray-400">{{ dealStatusLabel(d.status) }}</p>
            }
          </div>
          @if (d.value != null) {
          <span class="text-xs font-semibold text-brand-600 dark:text-brand-400 flex-shrink-0">
            {{ d.value | number:'1.0-0' }}
          </span>
          }
        </button>
        }
      </div>
    </div>
    }

    <!-- Tickets -->
    @if ((context?.tickets?.length ?? 0) > 0) {
    <div>
      <p class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1.5">
        Tickets ({{ context?.tickets?.length }})
      </p>
      <div class="space-y-1">
        @for (t of context?.tickets; track trackById($index, t)) {
        <button
          type="button"
          (click)="goToTicket(t.id)"
          class="w-full flex items-center justify-between gap-2 px-2 py-1.5 rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 hover:border-brand-300 dark:hover:border-brand-500/40 hover:bg-brand-50/50 dark:hover:bg-brand-500/5 transition-colors text-left">
          <p class="text-xs font-medium text-gray-900 dark:text-white truncate flex-1">{{ t.subject || 'Sin asunto' }}</p>
          @if (ticketStatusLabel(t); as estado) {
          <span class="text-[10px] px-1.5 py-0.5 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 flex-shrink-0">{{ estado }}</span>
          }
        </button>
        }
      </div>
    </div>
    }
    }
  </div>
  }
</div>
